export type Purchase = {
  name: string
  city: string
  region: string
}

/**
 * SAMPLE DATA. Only switch the notifications on (ENABLED in
 * PurchaseNotifications.tsx) once this list comes from real orders.
 */
export const recentPurchases: Purchase[] = [
  { name: 'Ashley M.', city: 'Minneapolis', region: 'Minnesota' },
  { name: 'Chloe B.', city: 'Calgary', region: 'Alberta' },
  { name: 'Emma R.', city: 'Sheffield', region: 'England' },
  { name: 'Megan T.', city: 'Boston', region: 'Massachusetts' },
  { name: 'Olivia P.', city: 'Melbourne', region: 'Victoria' },
  { name: 'Sophie L.', city: 'Ottawa', region: 'Ontario' },
  { name: 'Lauren K.', city: 'Colorado Springs', region: 'Colorado' },
  { name: 'Hannah W.', city: 'Glasgow', region: 'Scotland' },
]
